import { Auth } from 'aws-amplify'

import { S3Client } from '@aws-sdk/client-s3'
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers'

Auth.configure({
  region: process.env.REACT_APP_REGION,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
})

const s3Client = new S3Client({
  region: process.env.REACT_APP_REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: {
      region: 'us-east-1',
    },
    identityPoolId: 'us-east-1:4e3d1ada-1820-4f2b-ad0a-28a6de9343d7',
  }),
})

export { s3Client }
